<template>
   <main>
    
      
      <div class="section"></div>
      <span style="background:green;border-radius:20px 0px 20px 0px;">
        <img src="http://kakehashi-education-center.com/images/kakehashi_logo.jpg" class="responsive-img" />
      </span>
      <h5 class="indigo-text">Online Learning System ** Student **</h5>
      <div class="section"></div>

      <div class="container">
        <div class="z-depth-1 grey lighten-4 row" style="display: inline-block; padding: 15px 48px 0px 48px; border: 1px solid #EEE;">

          <form class="col s12" method="post" @submit="checkForm" >
            <div class='row'>
              <div class='col s12'>
              </div>
            </div>
            <p>Please Login Here</p>
            <div class='row'>
              <div class='input-field col s12'>
                <span for='code'>Enter your code</span>
                <input class='validate' type='text' v-model="code"  required/>
                
              </div>
            </div>

            <div class='row'>
              <div class='input-field col s12'>
                <span for='password'>Enter your password</span>
                <input class='validate' type='password' v-model="password"  required/>
                
              </div>
         
            </div>

            <br />
            <center>
              <div class='row'>
                
                 <loading-btn 
                      v-bind:button_type="'submit'"
                      v-bind:text="'Login'"
                      
                      v-bind:loading="loading"
                      v-bind:custom_class="'col s12 btn btn-large waves-effect'"
                ></loading-btn>
              </div>
            </center>
          </form>
        </div>
      </div>
   
   

    <div class="section"></div>
    <div class="section"></div>
  </main>
</template>
<script>
import { createFormData } from './../../misc/CreateFormData.js';
export default {
    name:"Login",
    data() {
        return {
            code: null,
            password: null,
        }
    },
    methods: 
    {
      checkForm(e)
      {
          e.preventDefault();
          if (this.code && this.password)
          {
              this.$store.dispatch("login",createFormData({
                "code":this.code,
                "password":this.password
              }));

          }
          
      }
    },
    computed: 
    {
      loading()
      {
        return this.$store.getters.login_loading;
      },
      auth()
      {
          return this.$store.getters.auth;
      }
    },
    watch: 
    {
      auth(newVal)
      {
        if (newVal!=null)
        {
          this.$router.push("/home");
        }
        else 
        {
          this.$router.push("/");
        }
      }
    }
      
      
            
      
}
</script>
<style lang="scss">

    @import "@/style/colors.scss";
    

      main {
      flex: 1 0 auto;
      text-align:center;
    }

    button 
    {
        background:$primaryButtonColor !important;
    }

    

    img
    {
        width:80px;
        height:30px;
    }

    .input-field 
    {
        text-align:left;
    }
 

    .input-field input[type=date]:focus + label,
    .input-field input[type=text]:focus + label,
    .input-field input[type=code]:focus + label,
    .input-field input[type=password]:focus + label {
      color: #e91e63;
    }

    .input-field input[type=date]:focus,
    .input-field input[type=text]:focus,
    .input-field input[type=code]:focus,
    .input-field input[type=password]:focus {
      border-bottom: 2px solid #e91e63;
      box-shadow: none;
    }
</style>